import { ChildrenItem } from "dependencies/base"
import { Button } from "./model"
import {
  home,
  bs,
  appHome,
  layout_title_drawer_button,
  list_page_drawer_button,
  app_multiFilter_drawer_button,
  wxLink_button,
  drawer_button,
  app_drawer_button,
  popover_button,
  app_popover_button,
  collect_button,
  like_button,
  ip_button,
  control_popover_button,
  page_return_button,
  bigScreen_return_button,
} from "./diffrence_options"
import bigScreenIcon from "assets/images/leftMenu/base/cx_button.png"
let icon = "icon-portal-menu_button"
let drawer_icon = "icon-portal-icon_drawer"
let popover_icon = "icon-portal-icon_popover"
let collect_icon = "icon-icon_collection"
let like_icon = "icon-portal-thumbs-up"
let ip_icon = "icon-portal_IP"
let return_icon = "icon-portal-back"
import bigScreen_return_icon from "assets/images/leftMenu/component/cx_return.png"

export let button_children = []
export let bigScreen_button_children = []
export let app_button_children = []
export let layout_title_drawer_button_children = []
export let list_page_drawer_button_children = []
export let app_multiFilter_drawer_button_children = []
export let wxLink_button_children = []
export let drawer_button_children = []
export let app_drawer_button_children = []
export let popover_button_children = []
export let app_popover_button_children = []
export let collect_button_children = []
export let like_button_children = []
export let ip_button_children = []
export let control_popover_button_children = []
export let return_button_children = []
export let bigScreen_return_button_children = []

let cover = [
  require("assets/images/leftMenu/button/style1.png"),
  require("assets/images/leftMenu/button/style2.png"),
  require("assets/images/leftMenu/button/style3.png")
]
for (let i = 0; i < home.length; i++) {
  button_children.push(new ChildrenItem("按钮样式" + (i + 1), icon, "cxButton", new Button(home[i]), cover[i]))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_button_children.push(new ChildrenItem("按钮样式" + i, bigScreenIcon, "cxButton", new Button(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_button_children.push(new ChildrenItem("按钮样式" + (i + 1), icon, "cxButton", new Button(appHome[i]), cover[i]))
}
for (let i = 0; i < layout_title_drawer_button.length; i++) {
  layout_title_drawer_button_children.push(
    new ChildrenItem("样式" + i, icon, "cxButton", new Button(layout_title_drawer_button[i]))
  )
}

for (let i = 0; i < list_page_drawer_button.length; i++) {
  list_page_drawer_button_children.push(
    new ChildrenItem("样式" + i, icon, "cxButton", new Button(list_page_drawer_button[i]))
  )
}

for (let i = 0; i < app_multiFilter_drawer_button.length; i++) {
  app_multiFilter_drawer_button_children.push(
    new ChildrenItem("样式" + i, icon, "cxButton", new Button(app_multiFilter_drawer_button[i]))
  )
}
for (let i = 0; i < wxLink_button.length; i++) {
  wxLink_button_children.push(
    new ChildrenItem("样式" + i, "icon-portal-weixin-app", "cxButton", new Button(wxLink_button[i]))
  )
}
for (let i = 0; i < drawer_button.length; i++) {
  drawer_button_children.push(new ChildrenItem("样式" + i, drawer_icon, "cxButton", new Button(drawer_button[i])))
}
for (let i = 0; i < app_drawer_button.length; i++) {
  app_drawer_button_children.push(
    new ChildrenItem("样式" + i, drawer_icon, "cxButton", new Button(app_drawer_button[i]))
  )
}

//收藏按钮
for (let i = 0; i < collect_button.length; i++) {
  collect_button_children.push(new ChildrenItem("样式" + i, collect_icon, "cxButton", new Button(collect_button[i])))
}

//点赞按钮
for (let i = 0; i < like_button.length; i++) {
  like_button_children.push(new ChildrenItem("样式" + i, like_icon, "cxButton", new Button(like_button[i])))
}

// 弹出框
for (let i = 0; i < popover_button.length; i++) {
  popover_button_children.push(new ChildrenItem("样式" + i, popover_icon, "cxButton", new Button(popover_button[i])))
}
for (let i = 0; i < app_popover_button.length; i++) {
  app_popover_button_children.push(
      new ChildrenItem("样式" + i, popover_icon, "cxButton", new Button(app_popover_button[i]))
  )
}
//IP按钮
for (let i = 0; i < ip_button.length; i++) {
  ip_button_children.push(new ChildrenItem("IP样式" + i, ip_icon, "cxButton", new Button(ip_button[i])))
}

// 弹出框关闭按钮
for (let i = 0; i < control_popover_button.length; i++) {
  control_popover_button_children.push(
    new ChildrenItem("样式" + i, icon, "cxButton", new Button(control_popover_button[i]))
  )
}

//返回按钮
for (let i = 0; i < page_return_button.length; i++) {
  return_button_children.push(new ChildrenItem("样式" + i, return_icon, "cxButton", new Button(page_return_button[i])))
}
//返回按钮 --- 大屏
for (let i = 0; i < page_return_button.length; i++) {
  bigScreen_return_button_children.push(new ChildrenItem("样式" + i, bigScreen_return_icon, "cxButton", new Button(bigScreen_return_button[i])))
}
